var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{ 'large-icon': _vm.largePreview }]},[(['JPG', 'PNG'].includes(_vm.assetFiletypeName))?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.assetUrl),expression:"assetUrl"}],class:[
      'absolute top-0 left-0 h-full rounded-sm',
      { 'w-full object-cover': !_vm.largePreview },
      { 'right-0 mx-auto w-auto object-contain shadow-lg': _vm.largePreview } ]}):_c(_vm.getFiletypeIcon(),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }